import "./MyRides.scss"
import { useEffect, useMemo, useState } from "react"
import { List, Box, Typography, Tabs, Tab } from "@mui/material"
import { useAppDispatch, useAppSelector } from "../../redux/hooks"
import {
  getReservationsAsync,
  selectReservationsList,
} from "../../redux/slices/reservationsSlice"
import { Rides } from "../../types/reservationsTypes"
import DropdownSelect from "../../components/DropdownSelect/DropdownSelect.component"
import { MonthItem, useGenerateLast12Months, useGenerateNext12Months } from "../../utils/dateUtils"
import calenderIcon from "../../assets/images/calender.png"
import avatarIcon from "../../assets/images/avatar.png"
import { useTranslationLabel } from "../../hooks/useTranslationLabel"
import {
  getDriversAsync,
  selectDriversList,
} from "../../redux/slices/driverSlice"
import { RideItem } from "./RideItem/RideItem"
import { Driver } from "../../types/driverTypes"
import { useLanguage } from "../../hooks/useLanguage"
import Loader from "../../components/Loader/Loader.component"
import { UserData } from "../../types/userTypes"
import { selectUserData } from "../../redux/slices/authSlice"

const MyRides = () => {
  const driversList: Driver[] = useAppSelector(selectDriversList)
  const userData: UserData | null = useAppSelector(selectUserData)

  const dispatch = useAppDispatch()
  const reservations = useAppSelector(selectReservationsList);
  const rides = reservations.reservationsList;
  const loading = reservations.loading;
  const monthItems: MonthItem[] = useGenerateLast12Months()
  const nextMonthItems: MonthItem[] = useGenerateNext12Months()
  const [selectedMonth, setSelectedMonth] = useState("")
  const [selectedDriver, setSelectedDriver] = useState("")

  const { SHOW_MORE, SELECT_DRIVER, BOOKED_RESERVATIONS, PAST_RESERVATIONS } = useTranslationLabel()
  const defaultDriverOption = { label: SELECT_DRIVER, value: "" }
  const driverOptions = driversList.map((driver) => ({
    label: `${driver.firstName} ${driver.lastName}`,
    value: driver.id.toString(),
  }))
  const [currentPage, setCurrentPage] = useState(1)
  const [count, setCount] = useState(4)
  const driverItems = [defaultDriverOption, ...driverOptions]
  const [selectedTab, setSelectedTab] = useState(0)
  const [selectedLanguage] = useLanguage()

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue)
  }

  const handleShowMoreClicked = () => {
    setCount((prevCount: number) => prevCount + 4)
  }

  useEffect(() => {
    dispatch(getDriversAsync())
  }, [dispatch])

  useEffect(() => {
    const isPast = selectedTab === 0
    dispatch(
      getReservationsAsync({
        selectedMonth,
        page: currentPage,
        count,
        isPast,
        locale: selectedLanguage,
      }),
    )
  }, [dispatch, selectedMonth, currentPage, count, selectedTab, userData])

  const ridesMemo = useMemo(() => {

    return selectedDriver
      ? rides.filter((ride) => ride.driverId.toString() === selectedDriver)
      : rides

  }, [rides, selectedDriver])



  return (
    <div className="my-rides-container column">
      <Box className="wrapper space-between">
        <DropdownSelect
          value={selectedMonth}
          onChange={(e) => setSelectedMonth(e.target.value)}
          items={selectedTab ? nextMonthItems : monthItems}
          startIcon={calenderIcon}
        />
        <DropdownSelect
          value={selectedDriver}
          onChange={(e) => setSelectedDriver(e.target.value)}
          items={driverItems}
          startIcon={avatarIcon}
        />
      </Box>

      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        className="my-rides-tabs"
      >
        <Tab label={PAST_RESERVATIONS} />
        <Tab label={BOOKED_RESERVATIONS} />
      </Tabs>
      {loading && <Loader />}
      <List className="rides-list">
        {ridesMemo.map((ride) => (
          <RideItem key={ride.id} ride={ride} />
        ))}
      </List>
    </div>
  )
}

export default MyRides
